import { t } from "i18next";
import { ComputeFieldComponent } from "../computeFields";
import { ArtworkInExhibition } from "../types";
import { SeparatedList } from "./shared/utils";
import { ComponentProps } from "react";
import { partitionAndRenderRelatedExhibitions } from "./itinerant-exhibition";

export const ExhibitionDescriptionCF: ComputeFieldComponent<
  Pick<
    ArtworkInExhibition,
    | "exhibition"
    | "oeuvresDansExpositionsDescriptionNumeroCatalogue"
    | "itinerantGroupId"
    | "itinerantOrder"
    | "itinerantNote"
  > & { id?: string }
> = ({ input, language, ...props }) => {
  return (
    <SeparatedList
      {...props}
      lineBreak={false}
      language={language}
      commaSeparated
      input={[
        <span
          dangerouslySetInnerHTML={{
            __html: input.exhibition.expositionsDescriptionResume,
          }}
        />,
        input.oeuvresDansExpositionsDescriptionNumeroCatalogue && (
          <>
            {t("computeField.numeroCatalogueAbbrege")}
            {input.oeuvresDansExpositionsDescriptionNumeroCatalogue}
          </>
        ),
      ]}
    />
  );
};

export const RelatedExhibitionsCF: ComputeFieldComponent<{
  relatedExhbitions?: ComponentProps<typeof ExhibitionDescriptionCF>["input"][];
  /** When true, group itinerant stops; when false, classic line-by-line. */
  groupItinerantExhibitions?: boolean;
}> = ({ input, lineBreak = true, language, ...props }) => {
  if (!input.relatedExhbitions || input.relatedExhbitions.length === 0) {
    return <></>;
  }

  if (!input.groupItinerantExhibitions) {
    return (
      <SeparatedList
        {...props}
        language={language}
        lineBreak={lineBreak}
        input={input.relatedExhbitions.map((ex, index) => (
          <ExhibitionDescriptionCF
            key={ex.id ?? ex.exhibition?.id ?? index}
            input={ex}
            language={language}
            {...props}
          />
        ))}
      />
    );
  }

  return (
    <>
      {partitionAndRenderRelatedExhibitions({
        links: input.relatedExhbitions,
        ClassicLine: ExhibitionDescriptionCF,
        language,
        lineBreak,
        ...props,
      })}
    </>
  );
};
